import {useState} from "react";
import {useEventListener} from "./useEventListener"

export function useWindowSize() {
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    })

    useEventListener("resize", () => {
        setWindowSize({width: window.innerWidth, height: window.innerHeight})
    })

    return windowSize
}

export function useTouch() {
    return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)
}